var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 10,
    fill: "#0492C2",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_105)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.1875 42.0625V14.75C30.1874 14.5351 30.1289 14.3243 30.0184 14.14C29.9078 13.9556 29.7494 13.8048 29.5598 13.7035C29.3703 13.6022 29.1568 13.5542 28.9422 13.5646C28.7275 13.5751 28.5197 13.6436 28.3409 13.7629L16.4659 21.6791C16.3031 21.7878 16.1696 21.935 16.0774 22.1078C15.9852 22.2805 15.9371 22.4734 15.9375 22.6692V42.0625H30.1875Z",
    fill: "#0492C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1875 42.0625V14.75C30.1874 14.5351 30.1289 14.3243 30.0184 14.14C29.9078 13.9556 29.7494 13.8048 29.5598 13.7035C29.3703 13.6022 29.1568 13.5542 28.9422 13.5646C28.7275 13.5751 28.5197 13.6436 28.3409 13.7629L16.4659 21.6791C16.3031 21.7878 16.1696 21.935 16.0774 22.1078C15.9852 22.2805 15.9371 22.4734 15.9375 22.6692V42.0625",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1875 23.0625H40.875C41.1899 23.0625 41.492 23.1876 41.7147 23.4103C41.9374 23.633 42.0625 23.9351 42.0625 24.25V42.0625",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 42.0625H45.625",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 26.625V29",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6875 26.625V29",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6875 34.9375V37.3125",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 34.9375V37.3125",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.17be4b7f4cd06f46db173b58e5679c4c.svg";
export { ForwardRef as ReactComponent };